export default __webpack_public_path__ + "static/logo-j-2-79906b8b23df804a41afc6947b8eff82.png";